import { API } from '~apis/axios/instance';
import { ResponseBaseWithData } from '~types/response';

export type NotificationSettingUpdateError = 'SUCCESS' | 'NO_RECIPIENT';
export interface UpdateCompanyUserNotificationSetting extends ResponseBaseWithData {
  code: NotificationSettingUpdateError;
}

/**
 * 회사의 구성원의 알림 메일 수신 설정을 수정한다.
 * @link https://apollo11.dev.clobe.ai/swagger-ui/index.html#/company-user-controller/updateNotificationSetting_1
 *
 * @param companyId
 * @param userId
 * @param type
 * @param checked
 */
export const updateCompanyUserNotificationSetting = ({
  companyId,
  userId,
  type,
  checked,
}: {
  companyId: string;
  userId: string;
  type: string;
  checked: boolean;
}) => {
  return API.patch<UpdateCompanyUserNotificationSetting>(
    `/api/v2/companies/${companyId}/users/${userId}/notification`,
    {
      data: {
        purpose: type,
        turnOn: checked,
      },
    },
  );
};
